import React from 'react'
import { Phone } from "../../../ui/phone/Phone"
import { Telegram } from "../../../ui/telegram/Telegram"
import styles from "./menu.module.css"
import { MarkupLayout } from '../../../ui/markupLayout/MarkupLayout'
import { Link } from 'react-router';
import { useUserStore } from '../../../../stores/useUserStore'
export function Menu({ items, active, setMenuActive }) {

    const { user } = useUserStore()

    return (
        <div className={active ? `${styles.open} open ` : styles.menu} onClick={() => setMenuActive(false)}>

            <div className={styles.menu__content} onTouchMoveCapture={(e) => {
                e.stopPropagation();
            }} onClick={(e) => { e.stopPropagation() }
            }>
                <MarkupLayout>
                    <div className={styles.wrapper}>
                        <div className={styles.menu__content_container}>
                            <ul className={styles.menu_list}>
                                {items.map((item) => {
                                    return <li key={item.text} > <Link onClick={() => setMenuActive(false)} to={item.to}>{item.text}</Link></li>
                                })}
                                {/* {user ? <li><Link onClick={() => setMenuActive(false)} to={"/profile"}>Личный кабинет</Link></li> : <li><Link onClick={() => setMenuActive(false)} to={'/login'} >Войти </Link>  </li>} */}
                            </ul>

                            <div className={styles.contacts_holder}>
                                <div className={styles.contacts}>
                                    <div className={styles.contacts_item}><a href="tel:+74992882648">+7 499 288-26-48</a></div>
                                    <div className={styles.contacts_item}><a href="mailto:info@sct-germany.ru">info@sct-germany.ru</a> </div>
                                </div>
                                <div className={styles.contacts__icons}>

                                    <Phone />
                                    <Telegram /></div></div>
                        </div>
                    </div>
                </MarkupLayout>

            </div>

        </div >
    )
}
